import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';

import AdminRolesManagement from '../../../components/SiteAdmin/AdminRolesManagement';
import Loader from '../../../components/Common/Loader/Loader';

import adminRolesQuery from './adminRolesQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';

class AdminRoles extends React.Component {

  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getAllAdminRoles: PropTypes.array,
    })
  };

  static defaultProps = {
    data: {
      loading: true
    }
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { data: { loading, getAllAdminRoles, refetch } } = this.props;

    return (
      <Loader type={"page"} show={loading}>
        {!loading && <AdminRolesManagement data={getAllAdminRoles} loading={loading} refetch={refetch} />}
      </Loader>
    )
  }
}

export default compose(
  injectIntl,
  withQuery(adminRolesQuery, {
    options: (props) => ({
      variables: {
        currentPage: 1
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  }),
)(AdminRoles);